import m from "../../es2015/lang/zh_Hans";
window.am4lang_zh_Hans = m;


//////////////////
// WEBPACK FOOTER
// ./lang/zh_Hans.js
// module id = null
// module chunks = 